import Flickity from 'flickity';
import themeUtils from '../themeUtils';
import ProductListItem from '../components/ProductListItem';

export default class DynamicFeaturedCollection {
  constructor(section) {
    this.el = section.el;
    this._flickity = this._flickity.bind(this);
    this._destroyFlickity = this._destroyFlickity.bind(this);
    this.productViews = [];
    this.container = this.el.querySelector('[data-products-container]');
    this.slide = '.product-list-item';
    this.flickity = null;

    this._bindEvents();
    this._setupProducts();
    this._flickity();
  }

  onSectionUnload() {
    window.removeEventListener('resize', themeUtils.debounce(this._flickity, 100));

    this._destroyFlickity();

    if (this.productViews.length) {
      // Destroy existing view listeners
      this.productViews.map((productView) => {
        productView.remove();
      });
    }
  }

  _bindEvents() {
    window.addEventListener('resize', themeUtils.debounce(this._flickity, 100));
  }

  _setupProducts() {
    this.el.querySelectorAll('.product-list-item').forEach(productItem => this.productViews.push(new ProductListItem({ el: productItem })));
  }

  _flickity() {
    if (!this.container) { return; }

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      this._destroyFlickity();
      return;
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.container, {
      cellAlign: 'left',
      cellSelector: this.slide,
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: false,
    });

    this._flickityEvents();
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;

      window.removeEventListener('resize', themeUtils.debounce(() => {
        const event = document.createEvent('Event');
        event.initEvent('home-featured-collections-height', true, true);
        this.container.dispatchEvent(event);
      }, 10));
      if (this.flickity) {
        this.container.removeEventListener('rimg:load', () => themeUtils.flickityResize(this.flickity));
      }

      this.container.removeEventListener('home-featured-collections-height', () => themeUtils.flickityResize(this.flickity));
    }
  }

  _flickityEvents() {
    const event = document.createEvent('Event');
    event.initEvent('home-featured-collections-height', true, true);

    // Check for tallest slide at start of transition
    this.flickity.on('cellSelect', () => this.container.dispatchEvent(event));

    // Check for tallest slide at end of transition
    this.flickity.on('settle', () => this.container.dispatchEvent(event));

    if (this.flickity) {
      this.container.addEventListener('rimg:load', () => themeUtils.flickityResize(this.flickity));
    }

    this.container.addEventListener('home-featured-collections-height', () => themeUtils.flickityResize(this.flickity));

    // Sets the Slider to the height of the first slide
    this.container.dispatchEvent(event);

    window.addEventListener('resize', themeUtils.debounce(() => this.container.dispatchEvent(event), 10));
  }
}
